<template>
    <aside id="sidebar" class="fixed z-20">

        <div id="topnav" class="pl-32 pr-32 pt-40 md-pt-16 md-pl-16 md-pr-16">
            <div class="flex justify-end closeBtn">
                <el-icon class="pointer" @click="sidebarToggle"><Close /></el-icon>
            </div>
            <div class="fw-semibold mb-8 text-darkblue fs-16 md-fs-14">{{ name }}</div>
            <div class="text-grey fs-14 md-fs-12">{{ email }}</div>
        </div>

        <nav class="sidebar-nav pr-16 pl-16 sm-p-0 sm-p-0">

            <ul>
                <li v-for="item, index in nav" :key="item['name'] + '-' + index">
                    <div class="hr" v-if="item['name'] === 'hr'"></div>
                    <div class="flex items-center gap-12 " v-else-if="!item['dropdown']">
                        <router-link v-if="item['show']" class="flex items-center gap-12 nav-item text-darkblue fs-16 md-fs-14" :to="item['url']" @click="sidebarToggle" @mouseenter="prefetchRoute(router, item['url'])">
                            <img class="icon mr-3 text-darkblue" alt="forside" width="23" height="21" :src="item['icon']"/><span>{{ item['name'] }}</span>
                        </router-link>
                    </div>
                    <div v-else>
                    <!-- eslint-disable -->
                        <div v-if="item['show']" :class="item['active'] ? 'dropdownactive' : ''" class="flex justify-between gap-12 items-center pointer relative sidebar-dropdown text-darkblue fs-16 md-fs-14" @click="item['url'] === undefined ? mainDropdowntoggle(index) : ''">
                            <div class="flex items-center gap-12">
                                <img class="icon mr-3 text-darkblue" alt="forside" width="23" height="21" :src="item['icon']"/><span>{{ item['name'] }}</span>
                            </div>
                            <span class="right-1 absolute">
                                <el-icon style="font-weight: 600;" :class="item['active'] ? 'rotate-open' : ''"><ArrowRight /></el-icon>
                            </span>
                        </div> <!--  v-if="ifDropdownAvailable(item)"  -->
                        <ul class="nav-dropdown-toggle" :class="item['active'] ? '' : 'toggleDropdown'" :id="'dropdown-' + index">
                            <li v-for="child, innerIndex in item['dropdown']">
                                <div v-if="child['dropdown'] && child['show']" :class="child['mobile'] !== undefined ? child['mobile'] ? 'mobileShow' : '' : 'none'">
                                    <div @click="dropdownToggle(index + '-' + innerIndex)" class="flex fs-16 md-fs-14 justify-between gap-12 items-center relative pointer text-darkblue">
                                        <router-link v-if="child['url'] && !child['dropdown']" :to="child['url']" class="flex gap-12 text-darkblue w-100 sidebar-dropdown" @click="sidebarToggle" @mouseenter="prefetchRoute(router, child['url'])">
                                            <div style="width: 23px; height: 23px;"></div>
                                            <span>{{ child['name'] }}</span>
                                        </router-link>
                                        <div v-else class="text-darkblue sidebar-dropdown relative z-10 flex justify-between items-center gap-12">
                                            <div class="flex items-center gap-12">
                                                <div style="width: 23px; height: 23px;"></div>
                                                <span>{{ child['name'] }}</span>
                                            </div>
                                            <span class="right-1 absolute">
                                                <el-icon v-if="ifDropdownAvailable(child)" style="z-index: -1; font-weight: 600;" :class="'icon-' + index + '-' + innerIndex" @click="dropdownToggle(index + '-' + innerIndex)"><ArrowRight /></el-icon>
                                            </span>
                                        </div>
                                    </div>
                                    <ul class="nav-dropdown-toggle toggleDropdown dropdown-child" :id="'dropdown-' + index + '-' + innerIndex"> <!-- toggleDropdown -->
                                        <li v-for="grandchild in child['dropdown']">
                                            <div class="nav-item" v-if="grandchild['show']">
                                                <router-link class="flex gap-12 text-darkblue fs-16 md-fs-14" :to="grandchild['url']" @click="sidebarToggle" @mouseenter="prefetchRoute(router, grandchild['url'])">
                                                    <div style="width: 23px; height: 23px;"></div>
                                                    <span>{{ grandchild['name'] }}</span>
                                                </router-link>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                                <div class="sidebar-nav-item" :class="child['mobile'] !== undefined ? child['mobile'] ? '' : 'desktopShow' : 'none'" v-else-if="child['show']">
                                    <router-link class="nav-item text-darkblue flex items-center gap-12 fs-16 md-fs-14" :to="child['url']" @click="sidebarToggle" @mouseenter="prefetchRoute(router, child['url'])">
                                        <div style="width: 23px; height: 23px;"></div>
                                        <span>{{ child['name'] }}</span>
                                    </router-link>
                                </div>
                            </li>
                        </ul>
                    <!-- eslint-enable -->
                    </div>
                </li>
            </ul>

        </nav>


    </aside>
    <div class="mobile-overlay" @click="closeSidebar"></div>
</template>

<script setup>
import { ElIcon } from 'element-plus'
/* eslint-disable */
import { ref, computed, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useSupplierStore } from '@/store/supplier'
import { usePrisenYear } from '@/utility/prisenYear'
import { ArrowRight, Close } from '@element-plus/icons-vue'
import { prefetchRoute } from '@/utility/prefetchRoute'

const route = useRoute()
const router = useRouter()
const supplierStore = useSupplierStore()
const { prisenyear } = usePrisenYear()
const staticBase = String(typeof __APP_STATIC_BASE__ !== 'undefined' ? __APP_STATIC_BASE__ : '/static').replace(/\/$/, '')
const staticIconBase = `${staticBase}/svg/icon`

const iconPath = (name) => `${staticIconBase}/${name}`

// State
const name = ref('Name')
const email = ref('email')
const haaid = ref(0)
const mainDropdowns = ref([])
const nav = ref([
    { name: 'hr' },
    { name: 'Forside', icon: iconPath('home.svg'), url: '/newsfeed', show: true, style: 'color: #003645;' },
    // { name: 'Kunder', icon: './static/svg/icon/kunder.svg', url: '/alle-moeder', show: false, isAffiliate: true, style: 'color: #003645;' },
    {
        name: 'Kunder',
        show: true,
        style: 'color: #003645;',
        active: false,
        icon: iconPath('kunder.svg'),
        dropdown: [
            {
                name: 'Markedsplads',
                style: 'color: #003645;',
                url: '/markedsplads',
                show: true,
                // dropdown: [
                //     {
                //         name: 'Offentlig Udbud',
                //         style: 'color: #003645;',
                //         url: '/offentlige-udbud',
                //        show: false
                //     }
                // ]
            },
            { name: 'Mine Kunder', url: '/alle-moeder', show: true, style: 'color: #003645;' },
            { name: 'Opret Tilbud', url: '/tilbud/inviter-kunde', show: true, style: 'color: #003645;' },
            // { name: 'Opret Tilbud', url: '/tilbud/jobskabelse', show: false, style: 'color: #003645;' },
            { name: 'Entreprisekontrakt', url: '/customer-projects/fastcontract-draft', show: false, style: 'color: #003645;' },
            { name: 'Prisberegner', url: '/tilbud/prisberegner', show: false, style: 'color: #003645;' },
            {
                name: 'Mester-til-Mester',
                style: 'color: #003645;',
                show: true,
                dropdown: [
                    {
                        name: 'Arbejdskraft',
                        style: 'color: #003645;',
                        url: '/mester-arbejdskraft',
                       show: true
                    },
                    {
                        name: 'Opgaver',
                        style: 'color: #003645;',
                        url: '/mester-opgaver',
                       show: true
                    }
                ]
            }
        ]
    },
    {
        name: 'Profil',
       show: false,
        style: 'color: #003645;',
        active: false,
        icon: iconPath('profil.svg'),
        dropdown: [
            { name: 'Mine Projekter', url: '/status-haandvaerker-new', show: true, style: 'color: #003645;' },
            { name: 'Opret Projekt', url: '/opret-projekt-new', show: true, style: 'color: #003645;' },
            {
                name: 'Anbefalinger',
                style: 'color: #003645;',
                url: '/anbefalinger',
               show: true,
                mobile: false
            },
            {
                name: 'Anbefalinger',
                style: 'color: #003645;',
                url: '/anbefalinger',
                show: true,
                mobile: true,
                dropdown: [
                    {
                        name: 'Indhent anbefalinger',
                        style: 'color: #003645;',
                        url: '/anbefalinger?tab=indhent',
                       show: true
                    },
                    {
                        name: 'Læs og besvar',
                        style: 'color: #003645;',
                        url: '/anbefalinger?tab=laesogbesvar',
                       show: true
                    },
                    {
                        name: 'Autopilot',
                        style: 'color: #003645;',
                        url: '/anbefalinger?tab=autopilot',
                       show: true
                    },
                    {
                        name: 'Widgets',
                        style: 'color: #003645;',
                        url: '/anbefalinger?tab=widgets',
                       show: true
                    }
                ]
            },
            { name: 'Hjemmeside', url: '/hjemmeside', show: false, style: 'color: #003645;' },
            { name: 'Medlemsfordele', url: '/medlemsfordele', show: true, style: 'color: #003645;' },
            { name: 'Webshop', url: '/webshop', show: false, style: 'color: #003645;' },
            { name: 'Digital Pakke', url: '/badges', show: true, style: 'color: #003645;' }
        ]
    },
    { name: 'hr' },
    { name: 'Indstillinger', show: true, icon: iconPath('settings.svg'), url: '/settings', style: 'color: #707070;' },
    { name: 'Ofte stillede spørgsmål', show: true, icon: iconPath('help.svg'), url: '/faq', style: 'color: #707070;' },
    { name: 'Log Ud', show: true, icon: iconPath('logout.svg'), url: '/login?noLanding=true', style: 'color: #707070;' }
])

// Computed
const getCompany = computed(() => supplierStore.company)
const getPrisen = computed(() => supplierStore.prisen)
const getNewsfeedv3 = computed(() => supplierStore.newsfeedV3)

// Watch
watch(() => route.name, (newRoute, oldRoute) => {
    // getSupplierInfoV2()
})

watch(getCompany, (newVal) => {
    if (newVal) {
        updateNavigation()
    }
}, { immediate: true })

// Functions
function mainDropdowntoggle (index) {
    nav.value.forEach((item, navInd) => {
        if (item['active'] !== undefined && navInd !== index) {
            item['active'] = false
        }
    })
    setTimeout(() => {
        nav.value[index].active = !nav.value[index].active
    }, 100)
}

function dropdownToggle (index) {
    const dropdown = document.querySelector('#dropdown-' + index)
    const icon = document.querySelector('.icon-' + index)
    if (!dropdown) return
    if (dropdown.classList.contains('toggleDropdown')) {
        dropdown.classList.remove('toggleDropdown')
        // icon.classList.add('rotate-open')
    } else {
        dropdown.classList.add('toggleDropdown')
        // icon.classList.remove('rotate-open')
    }
}

function getSupplierInfoV2 () {
    if (!getCompany.value) {
        supplierStore.fetchCompany()
    }

    updateNavigation()
}

function updateNavigation () {
    const company = getCompany.value
    const prisen = getPrisen.value

    if (!company) return

    if (company['UF_CRM_COMPANY_PACKAGE'] === 'affiliatepartner') {
        findNavItem(nav.value, 'Entreprisekontrakt', true)
        findNavItem(nav.value, 'Inviter kunde', true)
        findNavItem(nav.value, 'Opret Tilbud', true)
        findNavItem(nav.value, 'Markedsplads', false)
        findNavItem(nav.value, 'Prisberegner', false)
        findNavItem(nav.value, 'Anbefalinger', false)
        findNavItem(nav.value, 'Mester-til-Mester', false)
        findNavItem(nav.value, 'Gratis Hjemmeside', false)
        findNavItem(nav.value, 'Medlemsfordele', false)
        findNavItem(nav.value, 'Digital Pakke', false)
        findNavItem(nav.value, 'Profil', false)
    } else {
        findNavItem(nav.value, 'Kunder', true)
        findNavItem(nav.value, 'Profil', true)
        // findNavItem(nav.value, 'Markedsplads', true)
        if (company['UF_CRM_COMPANY_BOOKER_WIZARD']) {
            findNavItem(nav.value, 'Opret Tilbud', true)
            findNavItem(nav.value, 'Inviter Kunde', true)
        } else {
            findNavItem(nav.value, 'Opret Tilbud', false)
            findNavItem(nav.value, 'Inviter Kunde', false)
        }
        if (company['UF_CRM_COMPANY_PRISBEREGNING']) {
            findNavItem(nav.value, 'Prisberegner', true)
        } else {
            findNavItem(nav.value, 'Prisberegner', false)
        }
        if (company['UF_CRM_COMPANY_FAST_TRACK']) {
            findNavItem(nav.value, 'Entreprisekontrakt', true)
        } else {
            findNavItem(nav.value, 'Entreprisekontrakt', false)
        }
        if (localStorage.getItem('PartnerLoginUdbudJobs') === 'true') {
            findNavItem(nav.value, 'Offentlig Udbud', true)
        } else {
            findNavItem(nav.value, 'Offentlig Udbud', false)
        }
        if (prisen && company['UF_CRM_COMPANY_PRISEN_WEBSHOP'] === 1) {
            prisen.forEach(item => {
                if (item.YEAR == prisenyear.value)
                    findNavItem(nav.value, 'Webshop', true)
            })
        }
    }
}

function findNavItem (arr, targetName, action) {
    arr.forEach((item) => {
        if (item['name'] === targetName) {
            item['show'] = action
        }
        if (item['dropdown']) {
            findNavItem(item['dropdown'], targetName, action)
        }
    })
}

function ifDropdownAvailable (arr) {
    let result = false
    arr['dropdown'].forEach(item => {
        if (item['show'] === true) {
            result = true
        }
    })
    return result
}

function sidebarToggle (e) {
    if (e?.preventDefault)
        e.preventDefault()
    if (typeof window !== 'undefined' && window.innerWidth > 1024)
        return
    document.body.classList.toggle('sidebar-hidden')
    document.body.classList.toggle('sidebar-mobile-show')
}

function closeSidebar () {
    document.body.classList.add('sidebar-hidden')
    document.body.classList.remove('sidebar-mobile-show')
}

// Initialization (created equivalent)
if (route.name !== 'ProjectLogin') {
    haaid.value = localStorage.getItem('haaid')
    name.value = localStorage.getItem('CompanyName')
    email.value = localStorage.getItem('email')
    getSupplierInfoV2()
}
</script>

<style lang="scss" scoped>

@media only screen and (min-width: 1025px) {
    .sidebar-hidden {
        #sidebar {
            left: -340px !important;
        }
    }
}

@media only screen and (max-width: 1024px) {
    #sidebar {
        left: -340px !important;
    }
    .sidebar-mobile-show {
        position: relative;
        #sidebar {
            left: 0 !important;
        }

        .mobile-overlay {
            position: absolute;
            top: 0;
            left: 0;
            z-index: 15;
            width: 100%;
            height: 100%;
            background-color: rgba(0, 0, 0, 0.5);
            content: '';
        }
    }
}

#sidebar {
    @media only screen and (max-width: 500px) {
        .mobileShow {
            display: block;
        }
        .desktopShow {
            display: none;
        }
    }
    @media only screen and (min-width: 501px) {
        .desktopShow {
            display: flex;
        }
        .mobileShow {
            display: none;
        }
    }
}

</style>

<style scoped lang="scss">
@import "../../scss/elements/_sidebar.scss";

</style>